import React, { useEffect, useState } from "react";
import { Form, Badge, Row, Col } from "react-bootstrap";
import { BsX } from "react-icons/bs";
import "./styles.css";

const CHIP_COLORS = [
  { bg: "#007bff", text: "#fff" }, // Blue
  { bg: "#28a745", text: "#fff" }, // Green
  { bg: "#dc3545", text: "#fff" }, // Red
  { bg: "#ffc107", text: "#000" }, // Yellow
  { bg: "#17a2b8", text: "#fff" }, // Cyan
  { bg: "#6610f2", text: "#fff" }, // Purple
  { bg: "#e83e8c", text: "#fff" }, // Pink
  { bg: "#fd7e14", text: "#fff" }, // Orange
];

const ChipInputField = ({ chipsArrForEdit, setChips }) => {
  const [inputValue, setInputValue] = useState("");
  const [chipArr, setChipArr] = useState([]); // Store array of objects

  // Handle input change
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  // Convert text-only `chips` to `chipArr` with colors on mount & update
  useEffect(() => {
    if (chipsArrForEdit && chipsArrForEdit.length > 0) {
      const newChipArr = chipsArrForEdit.map((text) => ({
        text,
        color: CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)],
      }));
      setChipArr(newChipArr);
    }
  }, [chipsArrForEdit]); // Runs when `chips` changes

  // Handle Enter key to add chip
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      event.preventDefault();

      const newChipText = inputValue.trim();
      if (!chipArr.some((chip) => chip.text === newChipText)) {
        const randomColor =
          CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)];

        setChipArr([...chipArr, { text: newChipText, color: randomColor }]);
      }

      setInputValue(""); // Clear input field
    }

    // Remove last chip on Backspace when input is empty
    if (event.key === "Backspace" && inputValue === "" && chipArr.length > 0) {
      event.preventDefault();
      setChipArr(chipArr.slice(0, -1)); // Remove last chip
    }
  };

  // Remove chip when clicking X
  const handleDeleteChip = (chipToDelete) => {
    setChipArr(chipArr.filter((chip) => chip.text !== chipToDelete));
  };

  useEffect(() => {
    // console.log("chipArr__", chipArr);
    // if (chipArr.length > 0) {
    setChips(chipArr.map((item) => item.text));
    // }
  }, [chipArr]);

  return (
    <Row>
      <Col>
        <Form.Group className="chip-input-container">
          <h5 className="mt-4">Carrier Compatibility</h5>
          <div className="chip-input">
            {chipArr.map((chip, index) => (
              <Badge
                key={index}
                bg="error"
                pill
                className="chip custom-chip"
                style={{
                  backgroundColor: chip.color.bg,
                  color: chip.color.text,
                }}
              >
                <span className="chip-text">{chip.text}</span>
                <BsX
                  className="chip-delete"
                  onClick={() => handleDeleteChip(chip.text)}
                />
              </Badge>
            ))}
            <input
              type="text"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              placeholder="Type and press Enter"
              className="chip-text-input"
            />
          </div>
        </Form.Group>
      </Col>
    </Row>
  );
};

export default ChipInputField;
